import { render, staticRenderFns } from "./EffectTiles.vue?vue&type=template&id=1b7bc34c&scoped=true"
import script from "./EffectTiles.vue?vue&type=script&lang=js"
export * from "./EffectTiles.vue?vue&type=script&lang=js"
import style0 from "./EffectTiles.vue?vue&type=style&index=0&id=1b7bc34c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7bc34c",
  null
  
)

export default component.exports